import LokiJSAdapter from '@nozbe/watermelondb/adapters/lokijs';

import { demoSchema } from './schema';
import { demoMigrations } from './migrations';

export function createDemoAdapter() {
  return new LokiJSAdapter({
    schema: demoSchema,
    migrations: demoMigrations,
    useWebWorker: false,
    useIncrementalIndexedDB: true,
    dbName: 'bizplus_demo',
    onQuotaExceededError: (error: unknown) => {
      // Browser ran out of disk space -- offer the user to reload the app or log out
      console.error('[DemoDatabase] Quota exceeded:', error);
    },
    onSetUpError: (error: unknown) => {
      // Database failed to load -- offer the user to reload the app or log out
      console.error('[DemoDatabase] Setup error:', error);
    },
    extraIncrementalIDBOptions: {
      onDidOverwrite: () => {
        // Called when this adapter is forced to overwrite contents of IndexedDB.
        // This happens if there's another open tab of the same app that's making changes.
        // Try to synchronize the app now, and if user is offline, alert them that if they close this
        // tab, some data may be lost
        console.warn(
          '[DemoDatabase] IndexedDB was overwritten by another tab. Data may be out of sync.',
        );
      },
      onversionchange: () => {
        // database was deleted in another browser tab (user logged out), so we must make sure we delete
        // it in this tab as well - usually best to just refresh the page
        window.location.reload();
      },
    },
  });
}
